import axios from "axios";
import { WESBITE_LOADING, GET_WESBITE } from "./types";

export const getWesbite = () => (dispatch) => {
    dispatch(SetWesbiteLoading());
    axios
        .get("/api/users/get/website")
        .then((res) => {
            dispatch({
                type: GET_WESBITE,
                payload: res.data[0],
            });
            // console.log(res.data, "wesbite");
            dispatch(SetWesbiteLoading());
        })
        .catch((err) => {
            dispatch({
                type: GET_WESBITE,
                payload: null,
            });
            dispatch(SetWesbiteLoading());
        });
};

export const UpdateWesbite = (postData) => (dispatch) => {
    // dispatch(setProfileLoading());
    console.log("call ");
    axios
        .post("/api/users/website", postData)
        .then((res) => {
            console.log(res.data);
            // dispatch(setProfileLoading());
            dispatch(getWesbite());
        })
        .catch((err) => {
            console.log(err.response.data);
            // dispatch({
            //     type: GET_ERRORS,
            //     payload: err.response.data,
            // });
            // dispatch(setProfileLoading());
        });
};

export const SetWesbiteLoading = () => {
    return {
        type: WESBITE_LOADING,
    };
};
